import { render, staticRenderFns } from "./ManageUsers.vue?vue&type=template&id=70c7533e&"
import script from "./ManageUsers.vue?vue&type=script&lang=js&"
export * from "./ManageUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports